import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { CARD_LIST_ITEM_CLASSNAME } from '../../../constants/pdf'

import useStyles from './styles'

function AdCardListItem({ children, className }) {
  const classes = useStyles()

  return <div className={classnames(classes[CARD_LIST_ITEM_CLASSNAME], className)}>{children}</div>
}

AdCardListItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string
}

export default AdCardListItem
